
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFound: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md mx-auto">
        <CardContent className="pt-6 text-center space-y-4">
          <h1 className="text-3xl font-bold bg-gradient-to-r from-fasttrack-purple to-fasttrack-blue bg-clip-text text-transparent">
            Page Not Found
          </h1>
          <p className="text-muted-foreground">
            The page <code className="bg-secondary px-1 py-0.5 rounded">{location.pathname}</code> does not exist.
          </p>
        </CardContent>
        <CardFooter>
          <Button className="w-full" onClick={() => navigate('/')}>
            <Home className="mr-2" size={18} />
            Return to Home
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default NotFound;
